import React, { Fragment, useEffect } from "react";
import { Mui } from "@osu/react-ui";
import { compact, values as _values } from "lodash";
import { getUpdatedStepStateValues } from "../../steps";
import TextFieldGroup from "../TextFieldGroup";
import { createInputId, createLabelId } from "..";

const mappings = {
    keys: { firstName: "firstName", lastName: "lastName", email: "email" },
    labels: {},
    autoComplete: {},
}
mappings.labels = {
    [mappings.keys.firstName]: "First Name",
    [mappings.keys.lastName]: "Last Name",
    [mappings.keys.email]: "E-mail Address",
}       

mappings.autoComplete = {
    [mappings.keys.firstName]: "given-name",
    [mappings.keys.lastName]: "family-name",
    [mappings.keys.email]: "email",
}     

function ContactInformation(props = {}) {
    const { stepKey, stepState, updateStepState, user, elevation, validation, setValidation, formInvalid } = props;
    const { values } = stepState;

    const readOnly = !!user
    const updateState = (fieldName, fieldValue, parentFieldName = null) => {
        const updatedValues = getUpdatedStepStateValues(stepState, fieldName, fieldValue, parentFieldName = null);
        updateStepState(stepKey, { ...stepState, values: updatedValues });
    };

    /*
        When the validation changes, update isComplete.
        Applies only when there is no user.
        When there is a user, isComplete is automatically set to true when the Contact Information is updated with the user information.
    */
    useEffect(() => {
        const requiredFields = [stepState?.values?.firstName, stepState?.values?.lastName, stepState?.values?.email];
        const validationFlags = _values(validation);
        const isFormComplete = (
            compact(requiredFields).length === requiredFields.length && // has all required fields
            validationFlags.every(validationFlag => (validationFlag === true)) // all validation flags are true
        );
        if(!user && stepState.isComplete !== isFormComplete) updateStepState(stepKey, { ...stepState, isComplete: isFormComplete });
    }, [validation, stepKey, stepState, updateStepState, user]);

    const reviewId = "review-info-text"

    const inputGroupJsxArray = [
      mappings.keys.firstName,
      mappings.keys.lastName,
      mappings.keys.email,
    ].map((key, idx) => { 
      return <TextFieldGroup
          key={key + `-text-field-${idx}`}
          fieldKey={key}
          readOnly={readOnly}
          value={values[key] ?? ""}
          error={formInvalid ? !values?.[key] : validation?.[key] === false}
          setValidation={setValidation}
          updateState={updateState}
          elevation={elevation}
          id={createInputId(stepKey)}
          labelId={createLabelId(stepKey)}
      />
    })

    return (
        <Fragment>
            {readOnly && <Mui.Typography id={reviewId} variant="body2" color="secondary">Review your information. Updates can be made at
                {" "}{<Mui.Link target="_blank" rel="noopener" href="https://my.osu.edu">my.osu.edu</Mui.Link>}.{" "}
            </Mui.Typography>}
            {inputGroupJsxArray}
        </Fragment>
    );
}

export default ContactInformation